import { render, staticRenderFns } from "./ThanksForInvesting.vue?vue&type=template&id=0c28ef0a&"
import script from "./ThanksForInvesting.vue?vue&type=script&lang=ts&"
export * from "./ThanksForInvesting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports